export { CreateSchoolMutation } from './create-school';
export { UpdateSchoolMutation } from './update-school';
export { RemoveSchoolMutation } from './remove-school';
export { SendSchoolAccessMutation } from './send-school-access';
